// components.application.onboarding.business_info

export const BUSINESS_INFO = {
  title: 'Tell us about your company',
  operations_location: 'Location of Operations',
  button: { next: 'NEXT', save: 'SAVE' }
};
